export const TAG_TYPES = {
    SOLVENCY_DECLARATION: 'SolvencyDeclaration',
    TERMS_AND_CONDITIONS: 'TermsAndConditions',
    LOAN_APPLICATIONS: 'LoanApplications',
    INVESTMENTS: 'Investments',
    OPPORTUNITIES: 'Opportunities',
    INVESTMENT_DETAILS: 'InvestmentDetails',
    OFFER_DETAILS: 'OfferDetails',
    INVESTMENT_PORTFOLIO: 'InvestmentPortfolio',
    FUNCTIONALITIES: 'Functionalities',
    DOCUMENTS: 'Documents',
};
